import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "time-range-config-name"
}
const _hoisted_2 = {
  key: 1,
  class: "time-range-single"
}
const _hoisted_3 = { class: "time-range-config-name" }
const _hoisted_4 = {
  key: 2,
  class: "time-range-multiple"
}
const _hoisted_5 = { class: "time-range-config-name" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "time-range-config-item" }
const _hoisted_8 = {
  key: 0,
  class: "time-range-config-item"
}
const _hoisted_9 = {
  key: 1,
  class: "time-range-config-item"
}
const _hoisted_10 = {
  key: 2,
  class: "time-range-config-item"
}
const _hoisted_11 = {
  key: 3,
  class: "time-range-config-item"
}

import type { TimeRangeConfig } from './date_time_range_generators';
import type { TimeRange } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeRangeCard',
  props: {
    name: {},
    timeRange: {}
  },
  setup(__props: any) {

/* eslint-disable @typescript-eslint/no-unused-vars */
const formatDate = (date: Date): string => {
  try {
    return (new Date(date)).toLocaleDateString(undefined, { timeZone: 'UTC' });
  } catch (e) {
    console.error('Format Date in TimeRangeCard', date);
    return String(date);
  }
};

const props = __props;
// console.log('TimeRangeCard props:', props.timeRange.config);

return (_ctx: any,_cache: any) => {
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_hover = _resolveComponent("v-hover")!

  return (_openBlock(), _createBlock(_component_v_hover, null, {
    default: _withCtx(({ isHovering, props }) => [
      _createElementVNode("div", _mergeProps(props, { class: "time-range-card" }), [
        (__props.timeRange?.config === undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString((__props.name && __props.name!=='') ? __props.name : __props.timeRange.name), 1))
          : _createCommentVNode("", true),
        (__props.timeRange.config && __props.timeRange.config.type==='single')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString((new Date(__props.timeRange.config.singleDate)).toLocaleDateString(undefined, { timeZone: 'UTC'})), 1)
            ]))
          : _createCommentVNode("", true),
        (__props.timeRange.config && __props.timeRange.config.type==='multiple')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(__props.timeRange.name), 1),
              _createVNode(_component_v_expand_transition, null, {
                default: _withCtx(() => [
                  isHovering
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Date Range:", -1)),
                          _createTextVNode(" " + _toDisplayString(formatDate(__props.timeRange.config.dateRange.start)) + " - " + _toDisplayString(formatDate(__props.timeRange.config.dateRange.end)), 1)
                        ]),
                        (__props.timeRange.config.years)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Years:", -1)),
                              _createTextVNode(" " + _toDisplayString(__props.timeRange.config.years.join(', ')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (__props.timeRange.config.months)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Months:", -1)),
                              _createTextVNode(" " + _toDisplayString(__props.timeRange.config.months.map(s => s.slice(0,3)).join(', ')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (__props.timeRange.config.weekdays)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Weekdays:", -1)),
                              _createTextVNode(" " + _toDisplayString(__props.timeRange.config.weekdays.map(s => s.slice(0,3)).join(', ')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (__props.timeRange.config.times)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Times:", -1)),
                              _createTextVNode(" " + _toDisplayString(__props.timeRange.config.times.join(', ')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]))
          : _createCommentVNode("", true)
      ], 16)
    ]),
    _: 1
  }))
}
}

})